/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { PlatformModule } from '@angular/cdk/platform';
import { MatCommonModule } from '@angular/material/core';
import { MatProgressSpinner, MatSpinner } from './progress-spinner';
class MatProgressSpinnerModule {
}
MatProgressSpinnerModule.decorators = [
    { type: NgModule, args: [{
                imports: [MatCommonModule, PlatformModule],
                exports: [
                    MatProgressSpinner,
                    MatSpinner,
                    MatCommonModule
                ],
                declarations: [
                    MatProgressSpinner,
                    MatSpinner
                ],
            },] },
];
/**
 * @nocollapse
 */
MatProgressSpinnerModule.ctorParameters = () => [];
function MatProgressSpinnerModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatProgressSpinnerModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatProgressSpinnerModule.ctorParameters;
}
export { MatProgressSpinnerModule };
//# sourceMappingURL=progress-spinner-module.js.map